module.exports = __webpack_public_path__ + "img/20191220152107544.bdbc0423.jpg";